module.exports = new __parcel__URL__("laughing_chimp.5aa2d854.webp").toString();